import React from "react";
import CommonHeadingNBtns from "../common-components/CommonHeadingNBtns";
import { useFormik } from "formik";
import { versionSchema } from "../../schema/schema";
import { commonPostPutApi } from "../../redux/reducers/commonApiSlice";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import { addVersion } from "../../data/ApiEndpoints";
import SelectDropdown from "../components-react/SelectDropdown";
import { Form } from "react-bootstrap";
import { AppOptions } from "./versionutils";
import ReactQuill from "react-quill";

const AddVersion = ({ getVersionData, closeModal, token }) => {
  const dispatch = useDispatch();

  const formik = useFormik({
    initialValues: {
      app: "",
      wtf_version: "",
      apple_version: "",
      google_version: "",
      description: "",
      force_update: 0,
    },
    validationSchema: versionSchema,
    onSubmit: async (values) => {
      const method = "POST";
      const endpoint = addVersion;

      const payload = {
        type: values?.app,
        wtf_version: values?.wtf_version,
        apple_version: values?.apple_version,
        google_version: values?.google_version,
        description: values?.description,
        force_update: values?.force_update,
      };

      const result = await dispatch(
        commonPostPutApi({ method, endpoint, payload, token })
      );

      if (result?.payload?.status) {
        toast.success(result?.payload?.message || "Success!");
        closeModal();
        getVersionData();
      } else {
        const errorMessage = result?.error?.message || result?.payload?.message;
        toast.error(errorMessage || "Something Went Wrong!");
      }
    },
  });

  const onChangeInput = (e) => {
    formik.setFieldValue(e.target.name, e.target.checked ? 1 : 0);
  };

  return (
    <div className="createNewCTOModalContainer mod-width-70p">
      <CommonHeadingNBtns
        title="Add Version"
        onClick={formik.handleSubmit}
        isLoading={formik.isSubmitting}
        btnTxt="Save"
        onClose={closeModal}
      />

      <form className="formContainer" onSubmit={formik.handleSubmit}>
        <div className="formInputsGrid twoGridSystem">
          <div className="formInputBox">
            <label>
              Select App <RequiredField />{" "}
            </label>
            <div className="commonWrapper dropdownCommonWrapper">
              <SelectDropdown
                options={AppOptions}
                name="app"
                value={
                  AppOptions.find(
                    (option) => option.value === formik.values.app
                  ) || ""
                }
                setSelectedOption={(selectedOption) => {
                  formik.setFieldValue("app", selectedOption?.value);
                }}
                className="inputClass"
                placeholder="App"
                onBlur={formik.handleBlur}
              />
            </div>
            {formik.touched.app && formik.errors.app ? (
              <div className="error-message">{formik.errors.app}</div>
            ) : null}
          </div>

          <div className="formInputBox">
            <label>
              Apple Version <RequiredField />{" "}
            </label>
            <div className="formWapper">
              <input
                type="text"
                name="apple_version"
                className="inputClass"
                placeholder="Apple Version"
                value={formik.values.apple_version}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
            {formik.touched.apple_version && formik.errors.apple_version ? (
              <div className="error-message">{formik.errors.apple_version}</div>
            ) : null}
          </div>

          <div className="formInputBox">
            <label>
              WTF Version <RequiredField />{" "}
            </label>
            <div className="formWapper">
              <input
                type="text"
                name="wtf_version"
                className="inputClass"
                placeholder="WTF Version"
                value={formik.values.wtf_version}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
            {formik.touched.wtf_version && formik.errors.wtf_version ? (
              <div className="error-message">{formik.errors.wtf_version}</div>
            ) : null}
          </div>

          <div className="formInputBox">
            <label>
              Google Version <RequiredField />{" "}
            </label>
            <div className="formWapper">
              <input
                type="text"
                name="google_version"
                className="inputClass"
                placeholder="Google Version"
                value={formik.values.google_version}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
              />
            </div>
            {formik.touched.google_version && formik.errors.google_version ? (
              <div className="error-message">
                {formik.errors.google_version}
              </div>
            ) : null}
          </div>

          <div
            className="formInputBox"
            style={{
              gridColumn: "span 2",
            }}
          >
            <label>
              Description <RequiredField />{" "}
            </label>
            <div
              className="formWapper"
              style={{ height: "200px", backgroundColor: "#fff" }}
            >
              {/* <textarea
                type="text"
                name="description"
                className="inputClass"
                placeholder="Description"
                value={formik.values.description}
                onChange={formik.handleChange}
                onBlur={formik.handleBlur}
                style={{ height: "100px", padding: "10px" }}
              /> */}
              <ReactQuill
                theme="snow"
                value={formik.values.description}
                // onChange={formik.handleChange}
                onChange={(data) => formik.setFieldValue("description", data)}
                // onBlur={(e) => {
                //   console.log("Quill blur event:", e);
                //   formik.handleBlur(e);
                // }}
                onBlur={() => formik.setFieldTouched("description", true)}
                placeholder="Description"
                style={{ height: "80%" }}
              />
            </div>
            {formik.touched.description && formik.errors.description ? (
              <div className="error-message">{formik.errors.description}</div>
            ) : null}
          </div>

          <div className="formInputsGrid switchInputs">
            <div className="formInputBox formInputSwitchBox">
              <label>Force Update</label>
              <div
                className={`commonWrapper commonSwitchWrapper no-border`}
                style={{
                  width: "100%",
                  height: "100%",
                }}
              >
                <Form.Check
                  type="switch"
                  name="force_update"
                  // label={formik?.values?.force_update}
                  className="custom-switch"
                  checked={formik.values.force_update === 1}
                  onChange={onChangeInput}
                  // size="sm"
                />
              </div>
            </div>
          </div>
        </div>
      </form>
    </div>
  );
};

export default AddVersion;

const RequiredField = () => {
  return <span style={{ color: "red" }}>*</span>;
};
